import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { LoginBg } from "../../Assets";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  headerTitle: {
    fontSize: "32px !important",
    fontWeight: "800 !important",
    color: "#fff !important",
    letterSpacing: "0.44px",
  },
  headerTitle2: {
    marginTop: "-20px !important",
    fontSize: "44px !important",
    fontWeight: "800 !important",
    fontStyle: "italic",
    background: "linear-gradient(90deg, #E07E27 -22.62%, #E93301 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: "0.44px",
  },
  headerDescription: {
    fontSize: "14px",
    fontWeight: "300 !important",
    color: "#fff",
  },
  phoneInputContainer: {
    width: "100%",
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
  },
  // phoneInputWrapper: {
  //   width: "100% !important",
  //   maxWidth: "350px",
  // },
  phoneInput: {
    width: "100% !important",
    height: "54px !important", // Adjust height to match the image
    background: "#0D0D0D !important", // Dark background
    color: "#fff !important", // White text
    border: "1px solid transparent !important",
    borderRadius: "12px !important", // Smooth rounded edges
    fontSize: "18px !important",
    paddingLeft: "50px !important", // Space for the flag
    outline: "none",
    transition: "border 0.3s ease-in-out",
  },
  phoneInputWrapper: {
    display: "flex",
    alignItems: "center",
    borderRadius: "12px",
    // overflow: "hidden",
    position: "relative",
    border: "2px solid #E07E27", // Orange border
    backgroundColor: "#000",
    width: "100%",
    maxWidth: "350px",
    padding: "5px",
    boxShadow: "0px 0px 10px rgba(224, 126, 39, 0.6)", // Soft glow effect
  },
  phoneDropdown: {
    background: "transparent !important",
    border: "none !important",
    color: "#fff !important",
    paddingLeft: "10px !important",
  },
  phoneDropdownList: {
    background: "#1a1a1a !important",
    color: "#fff !important",
  },
  otpButton: {
    width: "100%",
    height: "60px !important",
    backgroundColor: "#E35C16 !important",
    color: "#fff !important",
    fontSize: "18px !important",
    fontWeight: "600 !important",
    borderRadius: "60px !important",
    "&:hover": {
      backgroundColor: "#E35C16 !important",
    },
  },
}));

export const otpContainerStyle = {
  display: "flex",
  justifyContent: "start",
  alignItems: "start",
} as React.CSSProperties;
